// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_GetContasDisponiveisResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /contas/get_contas_disponiveis/{franquia_id}
 *
 * Returns an ID-keyed map (`{ <conta_id>: { conta_nome, ..., formas_pagamento:
 * { <forma_id>: <forma_nome> } } }`) built by Contas_model::buscaDadosContas().
 * The top-level keys are runtime conta_ids, but every VALUE shares the
 * Contas_GetContasDisponiveisRow shape, so dados projects to
 * `Record<string, Contas_GetContasDisponiveisRow>` in TS.
 *
 * Note: this endpoint historically used the `data` envelope key (vs the
 * canonical `dados`). The migration normalizes to `dados` via sendResponse();
 * coordinate with the frontend if any consumer was reading `data`.
 */
import type { Contas_GetContasDisponiveisRow } from './Contas_GetContasDisponiveisRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Contas_GetContasDisponiveisResponseDados = Record<string, Contas_GetContasDisponiveisRow>;

export type Contas_GetContasDisponiveisResponse = ApiResponse<Contas_GetContasDisponiveisResponseDados>;

registerResponseContract('Contas_GetContasDisponiveisResponse', {})
